// src/layouts/quickbooks/Disconnected.js
// -----------------------------------------------------------------------------
// Page d’atterrissage après déconnexion QuickBooks.
// ⚠️ La révocation réelle des tokens se fait côté backend via POST /quickbooks/disconnect/.
// -----------------------------------------------------------------------------

import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function Disconnected() {
  const navigate = useNavigate();
  return (
    <Box textAlign="center" sx={{ py: 8 }}>
      <Typography variant="h4" gutterBottom>
        Déconnecté de QuickBooks
      </Typography>
      <Typography paragraph>
        La liaison avec QuickBooks a été supprimée. Vous pouvez relancer la connexion à tout moment.
      </Typography>
      <Button variant="contained" onClick={() => navigate("/quickbooks/launch")}>
        Reconnecter QuickBooks
      </Button>
    </Box>
  );
}
